<template>
    <div id="app">
        <navigation :profile='profile'></navigation>
        <b-row v-if='isLoading'>
            <b-col>
                <b-card>
                    <b-spinner variant="primary" label="Spinning"></b-spinner>
                </b-card>
            </b-col>
        </b-row>
        <router-view v-else :profile='profile' @submission='reloadProfile' />
    </div>
</template>

<script>
    import Navigation from '@/components/Navigation.vue';

    export default {
        components: {
            Navigation
        },
        data() {
            return {
                profile: null,
                isLoading: false
            };
        },
        methods: {
            reloadProfile() {
                this.$axios.get('/api/me').then((result) => {
                        this.profile = result.data;
                    }).catch(() => {
                        this.profile = null;
                    });
            }
        },
        created() {
            this.isLoading = true;
            this.$axios.get('/api/me').then((result) => {
                    this.profile = result.data;
                    this.isLoading = false;
                }).catch(() => {
                    this.profile = null;
                    this.isLoading = false;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    };

</script>


<style lang="scss">
    body {
        background: url('./assets/grass.png') repeat;
    }

    .spinner-container {
        margin-top: 4em;
    }

    div[class*="col-"],
    .col {
        margin-top: 2em;
    }

    .bottom-row {
        margin-bottom: 2em;
    }

    .page-container {
        margin-top: 2em;
        margin-bottom: 2em;

        .title-card {
            .row {
                margin-bottom: 0;
            }

            div[class*="col-"],
            .col {
                margin-top: 0;
            }
        }
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    #nav {
        padding: 30px;

        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }

    .text-success {
        path {
            fill: #28a745!important;
        }
    }

    .rcfbucks {
        height: 1em;
        width: 1em;
    }

</style>
